<!---------------------------------new ui---------------------------------------------------->


    <section class="content-header ">
    
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Brands</h1>
    </div>
    </div>
   
    </section>

    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader"></div>
    <!----------------------------------------------->
    
    <section class="content">
    
    <div class="card" *ngIf=CardShown>
    <div class="card-header">
    
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 20%">
    Brand Name
    </th>

    <th style="width: 20%">
    Brand Image
    </th>

    <th style="width: 25%">
    Brand Manager
    </th>

    <th style="width: 15%">
    Brand Code
    </th>
    
     
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.brand_name}}
    </a>
    </td>

    <td *ngIf="c.brand_images!='';else noImage"><img class="table-avatar" src="{{imgUrl+c.brand_images}}"></td>
    <ng-template #noImage>
      <td> </td>
    </ng-template>
    
     <td>
    {{c.brand_manager_name}}
    </td>
    
    
    <td>
    {{c.brand_code}}
    </td>
    
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)='BrandDetails();getValue(c.brand_id)'>
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left" (click)='getValue(c.brand_id);EditBrands()'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    <!--
    <a class="btn btn-danger btn-sm" href="#">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    -->
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>


<!---
<div class="card">
<div class="card-header">
    <h3 class="card-title">Brands</h3>
 </div>

 <div class="card-body">
    <div id="example2_wrapper" class="dataTables_wrapper dt-bootstrap4">
        <div class="row"><div class="col-sm-12 col-md-6"></div>
        <div class="col-sm-12 col-md-6"></div></div><div class="row">
        <div class="col-sm-12"><table id="example2" class="table table-bordered table-hover dataTable dtr-inline collapsed" role="grid" aria-describedby="example2_info">
    <thead>
    <tr role="row">
        <th class="sorting sorting_desc" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Rendering engine: activate to sort column ascending" aria-sort="descending">Brand Name</th>
        <th class="sorting" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Brand Id</th>
        <th class="sorting" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Brand Code</th>
    </thead>
    <tbody  *ngFor="let c of output">
    <tr class="odd" (click)='BrandDetails();getValue(c.brand_id)'>
    <td class="dtr-control sorting_1" tabindex="0">{{c.brand_name}}</td>
    <td>{{c.brand_id}}</td>
    <td>{{c.brand_code}}</td>
    </tr>
   </tbody>
    
    </table>
    </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-5">
        <div class="col-sm-12 col-md-7"><div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
               </div></div></div></div>
    </div>  -->
    <!----paging--------->
    <div *ngIf=CardShown>
    <div class="row">
        <div class="col-sm-12 col-md-5">
        <div class="col-sm-12 col-md-7"><div class="dataTables_paginate paging_simple_numbers " id="example2_paginate">
        </div></div></div></div>
        
<div class="col-sm-12 col-md-7">
    <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
        <ul class="pagination">
            <li class="paginate_button page-item previous" id="example2_previous">
            <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>

            <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link">{{count+1}}</a></li>
           
            <li class="paginate_button page-item next" id="example2_next">
            <a (click)="clicks_next()" aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
        </ul>
    </div></div>
</div>


    